/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductDetailedResponse } from '../../models/product-detailed-response';

export interface GetProductById$Params {

/**
 * UUID of the product (PackagingUnit)
 */
  packagingUnitId: string;

/**
 * If true, returns additional edit-mode metadata. Only effective for authenticated users.
 */
  editable?: boolean;
}

export function getProductById(http: HttpClient, rootUrl: string, params: GetProductById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDetailedResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductById.PATH, 'get');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.query('editable', params.editable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductDetailedResponse>;
    })
  );
}

getProductById.PATH = '/products/{packagingUnitId}';
